/* eslint-disable react-hooks/exhaustive-deps */
import { Backdrop, Box, Button, CircularProgress, Divider, Fade, Modal, Typography, useMediaQuery } from "@mui/material";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useTheme } from "@emotion/react";
import NotificationService from "../../../services/notificationService";


const ViewNotificationModal = ({ open,
    handleClose,
    notificationId }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));

    const [notification, setNotification] = useState({});
    const [isModalLoading, setIsModalLoading] = useState(true);

    const fetchNotification = async () => {
        try {
            const data = await NotificationService.fetchOne(notificationId);
            setNotification(data);
            setIsModalLoading(false);
        } catch (error) {
            console.error('Error fetching notification:', error);
        }
    };

    useEffect(() => {
        setIsModalLoading(true);
        if (open) {
            fetchNotification();
        }
    }, [open]);


    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            aria-hidden="false"
            aria-modal="true"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: isTablet ? '90%' : '60%',
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: isTablet ? 1 : 4,
                        height: '70vh',
                        overflowY: 'scroll'
                    }}
                >
                    {isModalLoading ? <Box sx={{ justifyContent: 'center', display: 'flex', my: 10 }} >
                        <CircularProgress color="primary" size={28} />
                    </Box>
                        : <Box>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'space-between'
                            }}>

                                <Typography id="transition-modal-title" variant="h6" component="h2">
                                    {t('notificationInfo')}
                                </Typography>
                                <CloseOutlinedIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
                            </Box>

                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: isTablet ? 'column' : 'row',
                                    width: '100%'
                                }}>

                                {/* col 1 */}
                                <Box width={isTablet ? '100%' : '50%'}>
                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('id')}: <span style={{ fontWeight: 'bold' }}>{notification.id}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('sender')}: <span style={{ fontWeight: 'bold' }}>{t(notification.sender)}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('senderName')}: <span style={{ fontWeight: 'bold' }}>{notification.senderPerson.name}</span>
                                    </Typography>
                                </Box>

                                {/* col 2 */}
                                <Box width={isTablet ? '100%' : '50%'}>
                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('createdAt')}: <span style={{ fontWeight: 'bold' }}>{notification.createdAt}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('reciver')}: <span style={{ fontWeight: 'bold' }}>{t(notification.reciver)}</span>
                                    </Typography>

                                    <Typography variant="body1" sx={{ mt: 2 }}>
                                        {t('reciverName')}: <span style={{ fontWeight: 'bold' }}>{notification.reciverPerson.name}</span>
                                    </Typography>
                                </Box>

                            </Box>

                            <Divider sx={{ mt: 2 }} />


                            {/* title */}
                            <Typography variant="body1"
                                sx={{
                                    mt: 2,
                                    wordWrap: 'break-word',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: 'block',
                                    maxHeight: '4.5em',
                                    lineHeight: '1.5em'
                                }}>
                                {t('titleKurdish')}: <span style={{ fontWeight: 'bold' }}>{notification.titleKurdish}</span>
                            </Typography>
                            <Typography variant="body1"
                                sx={{
                                    mt: 2,
                                    wordWrap: 'break-word',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: 'block',
                                    maxHeight: '4.5em',
                                    lineHeight: '1.5em'
                                }}>
                                {t('titleEnglish')}: <span style={{ fontWeight: 'bold' }}>{notification.titleEnglish}</span>
                            </Typography>
                            <Typography variant="body1"
                                sx={{
                                    mt: 2,
                                    wordWrap: 'break-word',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: 'block',
                                    maxHeight: '4.5em',
                                    lineHeight: '1.5em'
                                }}>
                                {t('titleArabic')}: <span style={{ fontWeight: 'bold' }}>{notification.titleArabic}</span>
                            </Typography>


                            {/* description */}
                            <Typography variant="body1"
                                sx={{
                                    mt: 2,
                                    wordWrap: 'break-word',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: 'block',
                                    maxHeight: '4.5em',
                                    lineHeight: '1.5em'
                                }}>
                                {t('descriptionKurdish')}: <span style={{ fontWeight: 'bold' }}>{notification.descriptionKurdish}</span>
                            </Typography>
                            <Typography variant="body1"
                                sx={{
                                    mt: 2,
                                    wordWrap: 'break-word',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: 'block',
                                    maxHeight: '4.5em',
                                    lineHeight: '1.5em'
                                }}>
                                {t('descriptionEnglish')}: <span style={{ fontWeight: 'bold' }}>{notification.descriptionEnglish}</span>
                            </Typography>
                            <Typography variant="body1"
                                sx={{
                                    mt: 2,
                                    wordWrap: 'break-word',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: 'block',
                                    maxHeight: '4.5em',
                                    lineHeight: '1.5em'
                                }}>
                                {t('descriptionArabic')}: <span style={{ fontWeight: 'bold' }}>{notification.descriptionArabic}</span>
                            </Typography>


                            <Box sx={{
                                display: 'flex', justifyContent: 'center', alignItems: 'center',
                                mt: 2
                            }}>
                                {/* close */}
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    sx={{ textTransform: 'none', width: 140, height: 40 }}
                                    onClick={handleClose}
                                >
                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <p>{t('close')}</p>
                                        <CloseOutlinedIcon fontSize="small" sx={{ mx: 0.4 }} />
                                    </Box>
                                </Button>

                                <Box width={20}></Box>

                            </Box>
                        </Box>
                    }
                </Box>
            </Fade>
        </Modal>
    );
}

export default ViewNotificationModal;
